import { Flex, FlexColumn } from '@ubeya/shared-web/components';
import { media, responsiveRow } from '@ubeya/shared-web/style';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled(Flex)`
  flex: 1;
  overflow: hidden;
  opacity: ${({ submitting }) => (submitting ? 0.3 : 1)};
  pointer-events: ${({ submitting }) => (submitting ? 'none' : 'all')};
  ${media.tablet`margin-top: 24px;`}
`;

const Page = styled(FlexColumn)`
  ${responsiveRow.tablet}
  overflow: auto;
  flex: 1;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};

  .error-text-wrapper {
    position: absolute;
    bottom: -20px;
  }
`;

const TabContent = ({ activeTab, submitting, children }) => (
  <Wrapper submitting={submitting}>
    {React.Children.toArray(children)
      .filter(Boolean)
      .map((child, index) => (
        <Page key={index} isVisible={activeTab === child.props.activeTab}>
          {child}
        </Page>
      ))}
  </Wrapper>
);

export default TabContent;
